import { defineNuxtPlugin } from "#app";

/**
 * Client side basket plug in
 */
export default defineNuxtPlugin( {
  name: "apollo-basket-client",
  parallel: true,
  async setup ( nuxtApp ) {
    const basketStore = useBasketStore();

    nuxtApp.hook( "apollo:auth:signin", async () => {
      // When the user signs in reload the client side basket
      await basketStore.refreshBasket();
    } );

    nuxtApp.hook( "apollo:auth:signout", async () => {
      // When the user signs out we need to clear out the basket store
      basketStore.removeClientBasket();
    } );

    basketStore.connectToStream();
  },
} );
